import { useMemo } from 'react'

import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'

import { INVERSION_PAGE_TYPES } from '../constants'
import { useInversionContext } from '../context/InversionContext'

export const useInversionFlags = () => {
  const { inversionData } = useInversionContext()
  const { appData } = useAppDataContext()

  const {
    storeList = { items: [] },
    communitiesList = { items: [] },
    cityServicesResidentialList = { items: [] },
    cityServicesBusinessList = { items: [] }
  } = inversionData || {}

  const isLocal = appData?.page?.isLocal === 'true'
  const pageType = appData?.page?.pageType || ''

  const [firstStoreItem] = storeList.items || []
  const [firstCommunityItem] = communitiesList.items || []
  const [firstResidentialItem] = cityServicesResidentialList.items || []
  const [firstBusinessItem] = cityServicesBusinessList.items || []

  const inversionProperties: any = useMemo(() => {
    if (pageType.includes(INVERSION_PAGE_TYPES.stores)) return firstStoreItem

    if (pageType.includes(INVERSION_PAGE_TYPES.communities)) {
      return firstCommunityItem
    }

    const residentialTypes = [
      INVERSION_PAGE_TYPES.services,
      INVERSION_PAGE_TYPES.services_city,
      INVERSION_PAGE_TYPES.services_state,
      INVERSION_PAGE_TYPES.services_offers,
      INVERSION_PAGE_TYPES.services_offers_int
    ]

    if (residentialTypes.includes(pageType)) {
      return firstResidentialItem
    }

    const businessTypes = [
      INVERSION_PAGE_TYPES.cb_services,
      INVERSION_PAGE_TYPES.cb_services_city,
      INVERSION_PAGE_TYPES.cb_services_state,
      INVERSION_PAGE_TYPES.cb_services_offers,
      INVERSION_PAGE_TYPES.cb_services_offers_ind
    ]

    if (businessTypes.includes(pageType)) {
      return firstBusinessItem
    }

    return []
  }, [pageType, inversionData])

  return { inversionProperties, isLocal }
}
